import React, { useState } from "react";
import { IoMdArrowDropright } from "react-icons/io";
import TreeView, { flattenTree } from "react-accessible-treeview";
import cx from "classnames";
import "./AgentOrg.scss";

const folder = {
  name: "Agency Headquarters", // Root of the agency structure
  children: [
    {
      name: "Agent Michael",
      children: [
        { name: "Subagent Emma" },
        { name: "Subagent Olivia" },
        { name: "Subagent Ava" },
        { name: "Subagent Isabella" },
        { name: "Subagent Sophia" },
      ],
    },
    {
      name: "Agent James",
      children: [
        { name: "Subagent Liam" },
        { name: "Subagent Noah" },
        { name: "Subagent Ethan" },
        {
          name: "Subagent Mason",
          children: [
            { name: "Subsubagent Charlotte" },
            { name: "Subsubagent Mia" },
            { name: "Subsubagent Amelia" },
            { name: "Subsubagent Harper" },
          ],
        },
      ],
    },
    {
      name: "Agent Emily",
      children: [
        { name: "Subagent Benjamin" },
        { name: "Subagent Jacob" },
        { name: "Subagent Michael" },
        { name: "Subagent Alexander" },
        { name: "Subagent William" },
      ],
    },
  ],
};

const data = flattenTree(folder);

function AgentOrg() {
  const [expandedIds, setExpandedIds] = useState();

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      getAndSetIds();
    }
  };

  const getAndSetIds = () => {
    setExpandedIds(
      document
        .querySelector("#txtIdsToExpand")
        .value.split(",")
        .filter((val) => !!val.trim())
        .map((x) => {
          if (isNaN(parseInt(x.trim()))) {
            return x;
          }
          return parseInt(x.trim());
        })
    );
  };

  return (
    <div className="basic">
      <div>
        <h3>Agent List</h3>
      </div>
      <p>This is a list of all agents associated to the user</p>
      <div className="checkbox">
        <TreeView
          data={data}
          aria-label="Controlled expanded node tree"
          expandedIds={expandedIds}
          //   defaultExpandedIds={[1]}
          nodeRenderer={({
            element,
            isBranch,
            isExpanded,
            isDisabled,
            getNodeProps,
            level,
            handleExpand,
          }) => {
            return (
              <div
                {...getNodeProps({ onClick: handleExpand })}
                style={{
                  marginLeft: 40 * (level - 1),
                  opacity: isDisabled ? 0.5 : 1,
                }}
              >
                {isBranch && <ArrowIcon isOpen={isExpanded} />}
                <span className="name">{element.name}</span>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
}

const ArrowIcon = ({ isOpen, className }) => {
  const baseClass = "arrow";
  const classes = cx(
    baseClass,
    { [`${baseClass}--closed`]: !isOpen },
    { [`${baseClass}--open`]: isOpen },
    className
  );
  // Apply a rotation transformation when isOpen is true
  const style = isOpen ? { transform: "rotate(90deg)" } : {};
  return <IoMdArrowDropright className={classes} style={style} />;
};

export default AgentOrg;
